import React, { useEffect, useRef, useState } from "react";
import { getVideoDetails } from "./service"
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VideoJS from '../../Components/VideoJsPlayer/VideoJS';
import { convertAdUrl, getEventInfo, imageUrlCheck, isHTML, onVideoPlayFunction } from "../../utils/utils";
import { manageGdprConsentModal, getGdprTCData } from "../../utils/gdprUtils";

import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { getPlayerToken, updateVideoWatchlistData, getUserSubscription, updateWatchlistData, authenticate } from "../../network/service";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
// import ContinueWatchingModel from "../../Components/Modals/ContinueWatchingModel";
import Loading from "../../Components/Loading/Loading";
import { ReactComponent as LeftArrow } from "../../assets/Icons/leftArrow.svg";
import { ReactComponent as AddListIcon } from "../../assets/Icons/addToList2.svg";
import { ReactComponent as RemoveListIcon } from "../../assets/Icons/removeFromList2.svg";
import ShowCard from "../../Components/ShowCard/ShowCard";
import { ReactComponent as PlayIcon } from "../../assets/Icons/godtvplay.svg";
import Select from "react-select";
import Comment from "../../Components/Comments/Components/Comments_container";
import Autoplay from "./Components/Autoplay";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import parse from "html-react-parser";
import Translate from "../../Components/Multilanguage/Translate";
import GaiaCard from "../../Components/ShowCard/GaiaCard";
import ParentalPasscodeModal from "../../Components/Modals/ParentalPasscodeModal";
import AgeConfirmModal from "../../Components/Modals/AgeConfirmModal";
import { isAgeConfirmedForSession } from "../../utils/ageConfirmation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { createBrowserHistory } from 'history';

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;

function VideoPlayer() {
    const location = useLocation()
    const videoId = location?.state?.videoDetails?.video_id;
    const { vanityUrl } = useParams()
    const datas = location?.state?.data;
    const showName = location?.state?.showname;
    const thumbnailOrientation = location?.state?.thumbnailOrientation;
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const sessionId = useSelector((state) => state?.sessionId?.value);
    const user = useSelector((state) => state?.user?.value);
    const isLive = location?.state?.isLive;
    const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);
    const ai_type = useSelector((state) => state?.aiType?.value);

    const [videoUrl, setVideoUrl] = useState();
    const [adUrl, setAdUrl] = useState("");
    const [videoDetails, setVideoDetails] = useState();
    const [videoTitle, setVideoTitle] = useState("");
    const [poster, setPoster] = useState("");
    const [loading, setLoading] = useState(true);
    const [watchListStatus, setWatchListStatus] = useState();
    const [vPlayer, setVPlayer] = useState();
    // const [isContinueWatchingModal, setIsContinueWatchingModal] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [isPlayingState, setIsPlayingState] = useState(false);
    const [initialOverlay, setInitialOverlay] = useState(true);
    const [subtitleInfo, setSubTitleInfo] = useState();
    const [closedCaptionInfo, setClosedCaptionInfo] = useState()
    const [watchedDuration, setWatchedDuration] = useState();
    const [isAutoplayView, setIsAutoplayView] = useState(false);
    const [watchedTime, setWatchedTime] = useState(0)
    const [multiLanguageOptions, setMultiLanguageOptions] = useState([])
    const [selectedAudioLanguage, setSelectedAudioLanguage] = useState({})
    const [upNext, setUpNext] = useState([])
    const [isFree, setIsFree] = useState(false);
    const [isPremium, setIsPremium] = useState(false);
    const [userSubscriptionData, setUserSubscriptionData] = useState([]);
    const [modalType, setModalType] = useState({ type: "logoutAll" });
    const [logoutModal, setLogoutModal] = useState(false);
    const [pinPending, setPinPending] = useState(false);
    const [pinPendingDuration, setPinPendingDuration] = useState(undefined);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [showAgeConfirmModal, setShowAgeConfirmModal] = useState(false);
    const agePendingDurationRef = useRef(0);

    const playerRef = useRef(null);
    const shouldPlayOnReadyRef = useRef(false);
    const [shouldPlayOnReady, setShouldPlayOnReady] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const showDetails = location?.state?.showDetails
    const showId = showDetails?.show_id;
    const videoType = location?.state?.showDetails?.type === "linear_event" ? "event" : "video";
    let showUniqueId = isMoreInfoOther?.showId ? isMoreInfoOther?.showId : showId;
    const continueWatch = location?.state?.continue;
    const watchDuration = videoDetails?.watched_duration;
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const theme = projectInfo?.projectConfig?.config?.THEME;
    const kids = template === 'TEMPLATE_12';
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            '&:hover': {
                borderColor: 'grey',
            },

        }),

        menu: (provided) => ({
            ...provided,
            top: 'auto',
            bottom: '100%',
            backgroundColor: 'grey',
        }),

        singleValue: (provided) => ({
            ...provided,
            color: theme === 'LIGHT' ? 'black' : 'white',
        }),

        placeholder: (provided) => ({
            ...provided,
            color: theme === 'LIGHT' ? 'black' : 'white',
        }),
    };
    let isAdPlaying = false;

    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
        sessionId,
    };
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        setVPlayer(null)
        setLoading(true)
        if (kids) {
            setIsAutoplayView(false)
            setShowVideo(false)
            setIsPlayingState(false)
            setInitialOverlay(true)
            setWatchedTime(0)
            setWatchedDuration(0)
            shouldPlayOnReadyRef.current = false
            setShouldPlayOnReady(false)
        }
        setSelectedAudioLanguage({})

        fetchVideoDetails();
    }, [location?.pathname]);

    useEffect(() => {
        const prepareAdUrlAndGdpr = async () => {
            const isSubscribed = Array.isArray(userSubscriptionData) ? userSubscriptionData.length > 0 : !!(userSubscriptionData?.status || userSubscriptionData?.user_subscription);
            manageGdprConsentModal({
                isSubscribed,
                countryCode: projectInfo?.geoInfo?.countryCode
            });
            const tcData = await getGdprTCData();
            setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive, isSubscribed, tcData));
        };

        prepareAdUrlAndGdpr();

        // playVideo();
        let persistedWatched = 0;
        if (videoDetails) {
            if (continueWatch) {
                persistedWatched = typeof watchDuration !== "undefined" ? watchDuration : (location?.state?.videoDetails?.watched_duration || 0);
            } else {
                persistedWatched = 0;
            }

            if (videoDetails?.is_mature_content === true && !isAgeConfirmedForSession()) {
                agePendingDurationRef.current = persistedWatched;
                setShowAgeConfirmModal(true);
            } else {
                beginPlayback(persistedWatched);
            }
        }
    }, [videoDetails, userSubscriptionData]);

    const beginPlayback = (persistedWatched) => {
        if (projectInfo?.projectConfig?.config?.TEMPLATE === 'TEMPLATE_12' && videoDetails?.parental_pin_required === true) {
            setPinPending(true);
            setPinPendingDuration(persistedWatched > 0 ? persistedWatched : undefined);
            setShowVerifyModal(true);
            if (persistedWatched > 0) {
                playVideo(persistedWatched);
            } else {
                playVideo();
            }
        } else {
            if (persistedWatched > 0) {
                playVideo(persistedWatched);
            } else {
                playVideo();
            }
        }
    };

    const onAgeConfirmed = () => {
        setShowAgeConfirmModal(false);
        beginPlayback(agePendingDurationRef.current || 0);
    };

    const onAgeDeclined = () => {
        setShowAgeConfirmModal(false);
        agePendingDurationRef.current = 0;
        goBack();
    };

    const onPinVerified = () => {
        setPinPending(false);
        setShowVerifyModal(false);
        if (pinPendingDuration) {
            playVideo(pinPendingDuration);
        } else {
            playVideo();
        }
    };

    useEffect(() => {
        setVPlayer(null);
        // if ((!isContinueWatchingModal || continueWatch) && videoUrl) {
        if (videoUrl) {
            const videoJsOptions = {
                autoplay: kids ? false : true,
                controls: true,
                responsive: true,
                fluid: true,
                bigPlayButton: kids ? false : true,
                controlBar: {
                    pictureInPictureToggle: false,
                },
                sources: [
                    {
                        src: `${videoUrl}`,
                        type: "application/x-mpegURL",
                    },
                ],
            };

            setVPlayer(
                <VideoJS
                    options={videoJsOptions}
                    onReady={handlePlayerReady}
                    adUrl={adUrl ? adUrl : null}
                    subtitles={subtitleInfo}
                    poster={poster}
                    watermark={videoDetails?.watermark}
                    kids={kids}
                />
            );
        }
    }, [videoUrl]);

    /*
    useEffect(() => {

        if (continueWatch && watchDuration > 0) {
            setIsContinueWatchingModal(false);
            playVideo(watchDuration);

        } else {
            //nothing to do
        }
    }, [continueWatch, watchDuration]);
    */

    useEffect(() => {
        logoutLimitCheck();
    }, [userSubscriptionData]);


    const handleClose = () => {
        document.body.className = "hideScroll";
        if (isMoreInfoOther?.isModal) {
            if (isMoreInfoOther?.isFromSearch) {
                if (location?.state?.isFromHome) {
                    navigate("/home");
                }
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                            isFromSearch: false,
                        })
                    );
                }, 600);
            } else {
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                        })
                    );
                }, 600);
            }
        } else {
            setTimeout(() => {
                dispatch(
                    getMoreInfo({
                        moreInfo: false,
                    })
                );
            }, 500);
        }

    };
    const redirectToLogin = () => {
        dispatch(
            getUser({
                user: null,
            })
        );
        localStorage.removeItem("userId");
        tokenAuthenticate();
        // navigate(projectInfo?.projectConfig?.config ?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout": "/login", {
        //     state: { path: location?.pathname, showId: showUniqueId,prevPath: location?.state?.prevPath ,activeLogin: true},
        // });
    };
    const fetchUserSubscriptionDetails = async () => {
        const userSubResponse = await getUserSubscription(appInfo);
        if (userSubResponse?.status === 200) {

            setUserSubscriptionData(userSubResponse?.data);
            dispatch(
                getUserSubscriptionData({
                    userSubscription: userSubResponse?.data,
                })
            );
        }
    };

    const updateVideoAnalytics = async (event, time, ai_type) => {
        const updateResponse = await onVideoPlayFunction(
            appInfo,
            videoDetails,
            event,
            time,
            "0",
            location?.state?.categories,
            showDetails?.show_id,
            ai_type
        );
    };

    const fetchVideoDetails = async () => {
        try {
            await fetchUserSubscriptionDetails();
            const showId = location?.state?.showId || location?.state?.showDetails?.show_id;
            const response = await getVideoDetails(vanityUrl, appInfo, showId);
            if (response?.status === 200) {
                setMultiLanguageOptions(response.data.data.audio_languages);
                setVideoDetails(response?.data?.data);
                setVideoTitle(response?.data?.data?.video_title)
                setPoster(response?.data?.data?.thumbnail_350_200)
                setUpNext(response?.data?.data?.up_next)
                setLoading(false)
                if (response?.data?.data?.watchlist_flag === 1) {
                    setWatchListStatus("added");
                } else {
                    setWatchListStatus("removed");
                }
                // if (response?.data?.data?.watched_duration > 0 && !continueWatch) {
                //     setIsContinueWatchingModal(true);
                // }
            } else if (response?.status === 401) {
                const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
                const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
                const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
                navigate(projectInfo?.projectConfig?.pubid !== 50124 && projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", {
                    replace: true,
                    state: {
                        ...location.state,
                        isFree: response?.data?.data?.free_video || false,
                        path: location?.pathname,
                        showId: showId,
                        isFrom: true,
                        from: "VideoPlayer",
                        prevPath: resolvedPrevPath,
                        activeLogin: true,
                        videoId: response?.data?.data?.video_id,
                        isRental: location?.state?.isRental || false,
                        checkoutDetails: location?.state?.checkoutDetails || {}
                    }
                });
            } else if (response?.status === 403) {
                const checkoutUrl = response?.data?.data?.checkout_link || response?.data?.data?.checkout_url;
                if (checkoutUrl) {
                    window.open(checkoutUrl, "_self");
                } else {
                    const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
                    const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
                    const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                        navigate("/checkout", {
                            replace: true,
                            state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} }
                        });
                    } else {
                        navigate("/subscription", {
                            replace: true,
                            state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} }
                        });
                    }
                }
            }
        } catch (err) {
            setLoading(false);
        }
    };
    const multiLanguageDropdownHandler = async (selectedOption) => {
        setSelectedAudioLanguage({ value: selectedOption.value, label: selectedOption.label, video_name: selectedOption.video_name })
        setWatchedTime(playerRef.current.currentTime())
        setVideoTitle(selectedOption?.video_title)
        startPlaying(selectedOption?.video_time, selectedOption.audio)
    }
    const tokenAuthenticate = async () => {
        const response = await authenticate(appInfo);
        if (response?.status === 200) {
            dispatch(
                getAccessToken({
                    accessToken: response?.data?.token,
                })
            );
        }
    };

    const logoutLimitCheck = () => {
        if (userSubscriptionData?.forcibleLogout === true) {
            setLogoutModal(true);
            setModalType({
                type: "logoutAll",
                heading: "You’ve reached the maximum Device limit.Do you want to logout from all devices",
            });
            return true;
        } else if (userSubscriptionData?.session_expired === true) {
            setModalType({ type: "redirect" });
            setLogoutModal(true);
            setTimeout(() => {
                handleClose();
                redirectToLogin();
            }, 1000);
            return true;
        }
        return false;
    }

    const playVideo = async (watchedLength) => {
        setShowVideo(true);
        if (watchedLength) {
            setWatchedDuration(watchedLength);
        }
        setSubTitleInfo(videoDetails?.subtitles);
        setClosedCaptionInfo(videoDetails?.closed_captions);
        const arr = videoDetails?.video_name?.split("/").reverse();
        const audio = videoDetails?.audio;
        const videoTime = videoDetails?.video_time;
        startPlaying(videoTime, audio);
    }

    const startPlaying = async (videoTime, audio) => {
        const playerTokenData = await fetchPlayerToken(videoTime);

        if (playerTokenData) {
            setVPlayer(null);
            if (audio) {
                setVideoUrl(
                    process.env.REACT_APP_API_URL +
                    "playlistV2/playlist.m3u8?id=" +
                    videoTime +
                    "&token=" +
                    playerTokenData +
                    "&type=" +
                    videoType +
                    "&pubid=" +
                    projectInfo?.projectConfig?.pubid +
                    "&audio=" + audio
                );
            } else {

                setVideoUrl(
                    process.env.REACT_APP_API_URL +
                    "playlistV2/playlist.m3u8?id=" +
                    videoTime +
                    "&token=" +
                    playerTokenData +
                    "&type=" +
                    videoType +
                    "&pubid=" +
                    projectInfo?.projectConfig?.pubid
                );
            }

        }
    }

    const handleTogglePlay = async () => {
        if (!showVideo) {
            shouldPlayOnReadyRef.current = true;
            setShouldPlayOnReady(true);
            setInitialOverlay(false);
            await playVideo();
            return;
        }

        if (playerRef.current) {
            try {
                if (playerRef.current.paused()) {
                    await playerRef.current.play();
                    setInitialOverlay(false);
                } else {
                    playerRef.current.pause();
                }
            } catch (e) {
                shouldPlayOnReadyRef.current = true;
                setShouldPlayOnReady(true);
            }
        }
    }

    const fetchPlayerToken = async (videoId) => {
        const playerTokenResponse = await getPlayerToken(appInfo, videoId);
        if (playerTokenResponse?.status === 200) {
            return playerTokenResponse?.data?.data;
        }
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        let wasPlayingBeforeAd = false;
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' && !player.isFullscreen()) {
                player.requestFullscreen().catch((error) => {
                    console.warn('Could not enter fullscreen:', error);
                });
            }
        });
        player.on("play", () => {
            if (isAdPlaying) return;

            setIsPlayingState(true);
            setInitialOverlay(false);
            let event = videoStarted == true ? "POP09" : "POP02";
            videoStarted = true;
            videoPlaying = true;
            if (ai_type) {
                updateVideoAnalytics(event, player.currentTime(), ai_type);
            } else {
                updateVideoAnalytics(event, player.currentTime());
            }

        });
        player.on("loadedmetadata", () => {
            // player.pause();
            if (isAdPlaying) return;
            const playRequested = shouldPlayOnReadyRef.current;
            if (watchedTime > 0) {
                player.currentTime(watchedTime.toString());
                if (!kids || playRequested) {
                    if (player.paused()) player.play();
                    videoPlaying = true;
                }
            } else if (watchedDuration > 0) {
                player.currentTime(watchedDuration.toString());
                if (!kids || playRequested) {
                    if (player.paused()) player.play();
                    videoPlaying = true;
                }
            } else {
                if (!kids || playRequested) {
                    if (player.paused()) player.play();
                    videoPlaying = true;
                }
            }
            if (playRequested && player.paused()) {
                player.play();
            }
            shouldPlayOnReadyRef.current = false;
            setShouldPlayOnReady(false);
            if (ai_type) {
                updateVideoAnalytics("POP02", player.currentTime(), ai_type);
            } else {
                updateVideoAnalytics("POP02", player.currentTime());
            }
        });
        player.on("timeupdate", function (e) {
            if (isAdPlaying) return;
            let event = "POP03";
            videoPlaying = true;
            var hasPlayedTime = player.currentTime();
            var intPlayedTime = parseInt(hasPlayedTime, 10);
            var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
            if (isSixty && debounce) {
                debounce = false;
                prevTime = intPlayedTime;
                if (ai_type) {
                    updateVideoAnalytics(event, player.currentTime(), ai_type);
                } else {
                    updateVideoAnalytics(event, player.currentTime());
                }
            } else {
                if (debounce == false && prevTime != intPlayedTime) {
                    debounce = true;
                }
            }
        });

        player.on("pause", () => {
            let event = "POP04";
            setIsPlayingState(false);
            if (isAdPlaying) return;
            if (ai_type) {
                updateVideoAnalytics(event, player.currentTime(), ai_type);
            } else {
                updateVideoAnalytics(event, player.currentTime());
            }
        });
        player.on("ended", () => {
            let event = "POP05";
            if (isAdPlaying) return;
            videoPlaying = false;
            setIsPlayingState(false);
            // episodeCount = findIndex() + 1;
            if (ai_type) {
                updateVideoAnalytics(event, player.currentTime(), ai_type);
            } else {
                updateVideoAnalytics(event, player.currentTime());
            }
            if (videoDetails?.video_type === "playlist") {
                const currentIndex = videoDetails.up_next.findIndex(
                    (video) => video.video_id === videoDetails.video_id
                );

                if (currentIndex < videoDetails.up_next.length - 1) {
                    setIsAutoplayView(true);
                }
            }

            if (videoDetails?.video_type !== "playlist" && videoDetails?.up_next?.length > 0) {
                setIsAutoplayView(true);
            }
        });
        player.on('adstart', () => {
            isAdPlaying = true;
            if (!player.paused()) {
                wasPlayingBeforeAd = true;
                player.pause();
            } else {
                wasPlayingBeforeAd = false;
            }
        });

        player.on('adend', () => {
            isAdPlaying = false;
            if (wasPlayingBeforeAd) {
                player.play();
            }
        });
        player.on("dispose", () => {
            isAdPlaying = false;
            videoPlaying = false;
            videoStarted = false;
            player.pause();
        });
        player.on('keydown', (e) => {
            if (isAdPlaying) return;

            if (e.which === 32 || e.which === 13) {
                e.preventDefault();
                player.paused() ? player.play() : player.pause();
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 37) {
                e.preventDefault();
                player.currentTime(player.currentTime() - 10);
            } else if (e.which === 39) {
                e.preventDefault();
                player.currentTime(player.currentTime() + 10);
            }
        });
        player.on('keydown', (e) => {
            if (e.which === 70 || e.which === 102) {
                e.preventDefault();
                player.requestFullscreen();
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 38) {
                e.preventDefault();
                player.volume(Math.min(player.volume() + 0.1, 1));
            } else if (e.which === 40) {
                e.preventDefault();
                player.volume(Math.max(player.volume() - 0.1, 0));
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 77 || e.which === 109) {
                e.preventDefault();
                player.muted(!player.muted());
            }
        });
        player.ready(() => {
            player.el().focus();
        });
    };

    const goBack = () => {
        if (location?.state?.backURL) {
            navigate(location.state.backURL);
        } else {
            navigate('/home');
        }

    };

    const searchHandler = (value, type) => {
        navigate(`/search?query=${value}`, { state: { type } });
    };

    const navigateToCategoryShowsListing = (vanityUrl) => {
        navigate(`/category/${vanityUrl}`, { state: { careers: vanityUrl } })
    }

    const handlePlaylistVideoChange = async (newVideo) => {
        setVPlayer(null);

        try {
            const showId = location?.state?.showId || location?.state?.showDetails?.show_id;
            const response = await getVideoDetails(newVideo.vanity_url, appInfo, showId);

            if (response?.status === 200) {
                const freshVideoData = {
                    ...response.data.data,
                    video_type: 'playlist',
                    vanity_url: response.data.data.vanity_url || newVideo.vanity_url
                };

                setVideoDetails(freshVideoData);
                setVideoTitle(freshVideoData.video_title);
                setPoster(freshVideoData.thumbnail_350_200);
                setWatchedTime(0);
                setWatchedDuration(0);
                setUpNext(freshVideoData.up_next || []);
                setMultiLanguageOptions(freshVideoData.audio_languages || []);
                setSubTitleInfo(freshVideoData.subtitles);
                setClosedCaptionInfo(freshVideoData.closed_captions);

                const vanityUrl = freshVideoData.vanity_url || newVideo.vanity_url;
                window.history.replaceState(
                    { videoDetails: freshVideoData },
                    '',
                    `/videos/${vanityUrl}`
                );

                const videoTime = freshVideoData?.video_time || 0;
                const audio = freshVideoData?.audio;
                startPlaying(videoTime, audio);
            }
        } catch (error) {
            console.error("Error fetching video details:", error);

            const updatedVideo = {
                ...newVideo,
                video_type: 'playlist'
            };

            setVideoDetails(updatedVideo);
            setVideoTitle(updatedVideo.video_title);
            setPoster(updatedVideo.thumbnail_350_200);

            const vanityUrl = updatedVideo.vanity_url || newVideo.vanity_url;
            window.history.replaceState(
                { videoDetails: updatedVideo },
                '',
                `/videos/${vanityUrl}`
            );

            const videoTime = updatedVideo?.video_time || 0;
            const audio = updatedVideo?.audio;
            startPlaying(videoTime, audio);
        }
    }

    const videoWatchlistHandler = async () => {
        if (!user) {
            navigate('/login', { state: { path: location?.pathname } });
            return;
        }
        const flag = watchListStatus === "added" ? 0 : 1;
        try {
            const response = await updateVideoWatchlistData(appInfo, videoDetails?.video_id, flag);
            if (response?.status === 200) {
                setWatchListStatus(flag === 1 ? "added" : "removed");
                if (flag === 1) {
                    toast.success("Added to My List", {
                        position: "bottom-center",
                        toastId: "watchlist_add",
                    });
                } else {
                    toast.success("Removed from My List", {
                        position: "bottom-center",
                        toastId: "watchlist_remove",
                    });
                }
            }
        } catch (err) {
            console.error(err);
        }
    };

    if (loading) {
        return <Loading />;
    }
    return (
        <div className='videoPlayerContainer' role="main" aria-label="Video Player Page">
            <ToastContainer />
            {showAgeConfirmModal && (
                <AgeConfirmModal onConfirm={onAgeConfirmed} onCancel={onAgeDeclined} />
            )}
            <ParentalPasscodeModal
                isOpen={showVerifyModal}
                mode="verify"
                appInfo={appInfo}
                showClose={true}
                onClose={() => navigate(-1)}
                onSuccess={onPinVerified}
            />
            <div className='wrapper'>
                {/*
                {!continueWatch && isContinueWatchingModal && (
                    <ContinueWatchingModel
                        setIsContinueWatchingModal={setIsContinueWatchingModal}
                        videoDetails={videoDetails}
                        playVideo={playVideo}
                        showDetails={showDetails}
                        appInfo={appInfo}
                        setAdUrl={setAdUrl}
                    />
                )}
                */}
                {logoutModal && (
                    <LogoutAllModal
                        showId={showUniqueId}
                        appInfo={appInfo}
                        setLogoutModal={setLogoutModal}
                        modalType={modalType}
                        videoDetails={videoDetails}
                        handleClose={handleClose}
                    />
                )}
                <div className="arrowContainer" onClick={goBack} role="button" tabIndex={0} aria-label="Go Back" onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { goBack(); } }}>
                    <h3>
                        <LeftArrow />
                    </h3>
                </div>
                <div className={`topContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}${kids && videoDetails?.video_type !== 'playlist' ? " kidsLayout" : ""}`} aria-label="Video Player Section">
                    <div className={kids && videoDetails?.video_type !== 'playlist' ? "kidsLeft" : "kidsLeftPassthrough"}>
                        <div className={`playerContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`} aria-label="Video Player">
                            {/* {!isContinueWatchingModal && vPlayer && ( */}
                            {vPlayer && (
                                <>
                                    {vPlayer}
                                    {kids && initialOverlay && (
                                        <div className="kidsPosterOverlay onTop" role="button" tabIndex={0} onClick={handleTogglePlay} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleTogglePlay(); }}>
                                            <img src={poster || videoDetails?.thumbnail_350_200} alt={videoTitle} />
                                            <div className="kidsPlayOverlay" aria-hidden="true">
                                                <div className="playIconContainer">
                                                    <PlayIcon />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            {
                                isAutoplayView &&
                                <Autoplay episodes={videoDetails?.up_next} setIsAutoplayView={setIsAutoplayView} isPlaylist={videoDetails?.video_type === 'playlist'} onVideoChange={handlePlaylistVideoChange} currentVideoId={videoDetails?.video_id} season={videoDetails?.season} template={template} thumbnailOrientation={thumbnailOrientation} />
                            }
                        </div>
                        {kids && videoDetails?.video_type !== 'playlist' && (
                            <>
                                <div className="multiAudio" aria-label="Audio Language Selection">
                                    {multiLanguageOptions?.length > 1 &&
                                        <div className="selectContainer">
                                            <Select
                                                styles={customStyles}
                                                options={multiLanguageOptions.map((video) => ({
                                                    value: video.language_name,
                                                    label: video.language_name,
                                                    video_name: video.video_name,
                                                    video_title: video.video_title,
                                                    video_time: video.video_time,
                                                    audio: video.audio
                                                }))}
                                                placeholder={multiLanguageOptions[0]?.language_name}
                                                onChange={multiLanguageDropdownHandler}
                                                value={selectedAudioLanguage && Object.keys(selectedAudioLanguage)?.length !== 0 ? selectedAudioLanguage : null}
                                                aria-label="Select audio language"
                                            />
                                        </div>}
                                </div>
                                <div className="videoMetaData" aria-label="Video Metadata">
                                    <div className="head">
                                        <h1 className="videoTitle">{videoTitle}</h1>
                                        <div className="actionsEnd" role="group" aria-label="Video actions">
                                            <div className="buttonContainer">
                                                <div className="background" />
                                                <button className="watchNowButton kidsWatchNow" onClick={handleTogglePlay} aria-label={isPlayingState ? "Pause" : "Watch Now"}>
                                                    <Translate textKey={isPlayingState ? 'pause' : 'watch_now'} />
                                                </button>
                                            </div>
                                            {watchListStatus === "added" ? (
                                                <div className="addtoList" role="button" tabIndex={0} aria-label="Remove from my list" onClick={videoWatchlistHandler} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') videoWatchlistHandler(); }}>
                                                    <div className="background" />
                                                    <RemoveListIcon />
                                                </div>
                                            ) : (
                                                <div className="addtoList" role="button" tabIndex={0} aria-label="Add to my list" onClick={videoWatchlistHandler} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') videoWatchlistHandler(); }}>
                                                    <div className="background" />
                                                    <AddListIcon />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {videoDetails?.categories?.length > 0 && (
                                        <div className="categoriesAndRating">
                                            <div className="categories">
                                                {videoDetails.categories.map((item, index) => (
                                                    <span className="category" key={index} onClick={() => navigateToCategoryShowsListing(item?.key)} role="button" tabIndex={0} aria-label={`View category ${item?.category_name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategoryShowsListing(item?.key); }}>{item?.category_name}</span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {videoDetails?.go_ads_free && (
                                        <div className="watchNow">
                                            <button onClick={() => {
                                                const adFreePrevPath = location?.pathname;
                                                if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                                                    navigate("/checkout", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: adFreePrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                                                } else {
                                                    navigate("/subscription", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: adFreePrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                                                }
                                            }}>
                                                <Translate textKey={'go_ads_free'} />
                                            </button>
                                        </div>
                                    )}
                                    <p className="description">
                                        {videoDetails?.video_description && (
                                            isHTML(videoDetails?.video_description)
                                                ? <span dangerouslySetInnerHTML={{ __html: videoDetails?.video_description }} />
                                                : videoDetails?.video_description
                                        )}
                                    </p>
                                </div>
                            </>
                        )}
                    </div>
                    {videoDetails?.video_type === 'playlist' && (
                        <div className="upNextSidebar" role="region" aria-label="Up Next Playlist">
                            {Array.isArray(upNext) && upNext.length > 0 && upNext[0]?.season && upNext[0]?.videos ? (
                                <div className="upNextList">
                                    {upNext.map((seasonObj, sIdx) => (
                                        <div key={seasonObj.season || sIdx} className="upNextSeasonGroup">
                                            <h2 className="seasonHeading">{seasonObj.season}</h2>
                                            {seasonObj.videos?.map((video) => (
                                                <div
                                                    className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                                                    key={video.video_id}
                                                    onClick={() => handlePlaylistVideoChange(video)}
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-label={`Play ${video.video_title}`}
                                                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { handlePlaylistVideoChange(video); } }}
                                                >
                                                    <div className='upNextTop'>
                                                        <div className={`upNextThumbnail${video.challenge_completed ? ' blurred' : ''}`}>
                                                            <img
                                                                src={video.thumbnail_350_200}
                                                                alt={video.video_title}
                                                            />
                                                            {video.challenge_completed && (
                                                                <span className="challenge-completed-indicator" title="Completed">
                                                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                                                                        <path d="M5 13L9 17L20 8" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="metaData">
                                                            <div className="upNextTitle">
                                                                {video?.video_title}
                                                            </div>
                                                            <div className="upNextDuration">
                                                                {video?.duration_text}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                                                        {isHTML(video?.video_description)
                                                            ? <span dangerouslySetInnerHTML={{ __html: video?.video_description }} />
                                                            : video?.video_description}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <>
                                    <h1 className="heading">
                                        {upNext?.length} <Translate textKey={'videos'} />
                                    </h1>
                                    <div className="upNextList">
                                        {upNext?.map((video) => (
                                            <div
                                                className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                                                key={video.id}
                                                onClick={() => handlePlaylistVideoChange(video)}
                                                role="button"
                                                tabIndex={0}
                                                aria-label={`Play ${video.video_title}`}
                                                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { handlePlaylistVideoChange(video); } }}
                                            >
                                                <div className='upNextTop'>
                                                    <div className="upNextThumbnail">
                                                        <img
                                                            src={video.thumbnail_350_200}
                                                            alt={video.video_title}
                                                        />
                                                    </div>
                                                    <div className="metaData">
                                                        <div className="upNextTitle">
                                                            {video?.video_title}
                                                        </div>
                                                        <div className="upNextDuration">
                                                            {video?.duration_text}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                                                    {isHTML(video?.video_description)
                                                        ? <span dangerouslySetInnerHTML={{ __html: video?.video_description }} />
                                                        : video?.video_description}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    {kids && videoDetails?.video_type !== 'playlist' && upNext?.length > 0 && (
                        <div className="kidsSidebar" role="region" aria-label="Try These Next">
                            <h1 className="heading"><Translate textKey={'try_these_next'} /></h1>
                            <div className="kidsSidebarList" onClick={() => setIsAutoplayView(false)}>
                                {upNext.map((video, index) => (
                                    <div className="kidsSidebarItem" key={video.id || index}>
                                        <ShowCard data={video} type="Episode" thumbnailOrientation={thumbnailOrientation} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                {!(kids && videoDetails?.video_type !== 'playlist') && <div className="multiAudio" aria-label="Audio Language Selection">
                    {multiLanguageOptions?.length > 1 &&
                        <div className="selectContainer">
                            <Select
                                styles={customStyles}
                                options={multiLanguageOptions.map((video) => ({
                                    value: video.language_name,
                                    label: video.language_name,
                                    video_name: video.video_name,
                                    video_title: video.video_title,
                                    video_time: video.video_time,
                                    audio: video.audio
                                }))}
                                placeholder={multiLanguageOptions[0]?.language_name}
                                onChange={multiLanguageDropdownHandler}
                                value={selectedAudioLanguage && Object.keys(selectedAudioLanguage)?.length !== 0 ? selectedAudioLanguage : null}
                                aria-label="Select audio language"
                            />
                        </div>}
                </div>}

                {!(kids && videoDetails?.video_type !== 'playlist') && <div className="videoMetaData" aria-label="Video Metadata">
                    <div className="head">
                        <h1 className="videoTitle">{videoTitle}</h1>
                    </div>
                    <div className="categoriesAndRating">
                        <div className="categories">
                            {(template === "TEMPLATE_9" || template === "TEMPLATE_12") && videoDetails?.categories?.map((item, index) => (
                                <span className="category" onClick={() => { navigateToCategoryShowsListing(item?.key) }} role="button" tabIndex={0} aria-label={`View category ${item?.category_name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { navigateToCategoryShowsListing(item?.key); } }}>{item?.category_name}</span>
                            ))}
                        </div>

                    </div>

                    {videoDetails?.go_ads_free && (
                        <div className="watchNow">
                            <button
                                onClick={() => {
                                    const adFreePrevPath = location?.pathname;
                                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                                        navigate("/checkout", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: adFreePrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                                    } else {
                                        navigate("/subscription", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: adFreePrevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                                    }
                                }}
                            >
                                <Translate textKey={'go_ads_free'} />
                            </button>
                        </div>
                    )}

                    <p className="description">
                        {(template === "TEMPLATE_9" || template === "TEMPLATE_12") && videoDetails?.video_description && (
                            isHTML(videoDetails?.video_description)
                                ? <span dangerouslySetInnerHTML={{ __html: videoDetails?.video_description }} />
                                : videoDetails?.video_description
                        )}
                    </p>

                    <div className="extraInfoContainer">
                        {videoDetails?.video_tags?.length > 0 && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'tags'} /></h6>
                                <div className="items oneRow">
                                    {videoDetails?.video_tags?.length > 0 &&
                                        videoDetails?.video_tags?.map((item, index) => (
                                            <span className="item" onClick={() => searchHandler(item, "tags")} role="button" tabIndex={0} aria-label={`Search tag ${item}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item, "tags"); } }}>
                                                {item}
                                                <span className="comma">,</span>
                                            </span>
                                        ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.cast?.length > 0 && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'cast'} /></h6>
                                <div className="items">
                                    {videoDetails?.cast?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "cast")} role="button" tabIndex={0} aria-label={`Search cast ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "cast"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.crew?.length > 0 && (template === "TEMPLATE_9" || template === "TEMPLATE_12") && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'crew'} /></h6>
                                <div className="items">
                                    {videoDetails?.crew?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "crew")} role="button" tabIndex={0} aria-label={`Search crew ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "crew"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>}

                <div>
                    {upNext?.length > 0 && videoDetails?.video_type !== 'playlist' && videoDetails?.season && !(kids && videoDetails?.video_type !== 'playlist') && (
                        <div className="upNextContainer" role="region" aria-label="Up Next">
                            <h1 className="heading"><Translate textKey={'upnext'} /> {videoDetails?.season && (<>{' '}<Translate textKey={'inseason'} />{' '}{videoDetails?.season}</>)} </h1>
                            <div className="upNext" onClick={() => setIsAutoplayView(false)}>
                                {upNext?.map((video, index) => (
                                    <div className={(thumbnailOrientation === "PORTRAIT" || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT") ? "itemPortrait" : "item"} key={video.id + index} role="button" tabIndex={0} aria-label={`Play ${video.video_title}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { setIsAutoplayView(false); } }}>
                                        {template === "TEMPLATE_10" ? (<GaiaCard data={video} type="Episode" thumbnailOrientation={thumbnailOrientation} />) : (<ShowCard data={video} type="Episode" thumbnailOrientation={thumbnailOrientation} />)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" &&
                    <div className="wrapper" aria-label="Comments Section">
                        <Comment videoId={videoDetails?.video_id} projectInfo={projectInfo} />
                    </div>
                }

            </div>
        </div>
    )
}

export default VideoPlayer
